module.exports = false;


//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_library.js
// module id = 47
// module chunks = 0